export default __webpack_public_path__ + "static/media/folderOpen.1e5871d1.svg";